import React from 'react';
import { injectIntl, FormattedMessage, FormattedPlural } from 'react-intl';
import { getStageName, i18nIntl } from '../../lib/ep';
import { useCSS } from '../../lib/hooks';

import ActionButton, { SecondaryButton } from '../builder/ActionButton';
import ButtonCollection from '../builder/ButtonCollection';
import SaveButton from '../builder/SaveButton';
import FloatingLayer from '../builder/FloatingLayer';
import Message from '../builder/Message';
import SectionSubtitle from '../builder/SectionSubtitle';
import SectionTitle from '../builder/SectionTitle';

import { OnlyGallery } from '../front/SingleGallery';

export const delMedia = (participation, confirm, is_voting, cb) => {
	if(confirm !== undefined && confirm == true) {
		$.post(`/users/delete/${participation.id}/${participation.promotion_id}`, { blacklist:false }, (response) => {
			if(cb != undefined) cb();
		});
		return;
	}
	
	if (is_voting) {
		$.post(`/stages/delet_vote_info/${participation.promotion_id}/${participation.stage}`,{ id:participation.id }, (response) => {
			if(cb != undefined) cb(response);
		}, 'JSON');
		return;
	}
	
	$.post(`/stages/delete_media/${participation.promotion_id}/${participation.stage}`, { id:participation.id }, (response) => {
		if(cb != undefined) cb(response);
	}, 'JSON');
};

const DeleteUserConfirm = ({ response, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	useCSS('comp/multigallery.css');
	useCSS('comp/owner_multigallery.css');

	const is_voting = props?.is_voting ?? false;

	let section_title = "Warning!";
	let section_subtitle;

	if(is_voting) {
		return (
			<FloatingLayer _class={{size:'small'}} backButton={props.backButton}>
				<div>
					<SectionTitle _class={{icon:'knk-alert redIcon'}}>{section_title}</SectionTitle>
					<SectionSubtitle>Do you confirm that you want to delete this participation and remove the votes from these candidates?</SectionSubtitle>

					<Message
						icon={false}
						_class={{ other:'in_top in_bottom' }}
					>
						<ul class="votes_per_gallery">
							{response.participation.quiz_entry.votes.map((vote, v) => {
								const vote_count = vote.score;

								return (
									<li key={`voted_${v}`}>
										<strong>{response.medias[vote.id].User.name}: </strong>
										<FormattedPlural value={vote_count} one={<FormattedMessage id="{num} point" values={{num:vote_count}} />} other={<FormattedMessage id="{num} points" values={{num:vote_count}} />} />
									</li>
								)
							})}
						</ul>
					</Message>

					<ButtonCollection in_floating={true}>
						<SaveButton
							type="confirm"
							onClick={props.confirm}
						>Yes, continue</SaveButton>

						<SecondaryButton
							onClick={props.backButton}
							color='red'
						>Cancel</SecondaryButton>
					</ButtonCollection>
				</div>
			</FloatingLayer>
		)
	}

	switch(response.status) {
		case 0:
			section_subtitle = "This entry is displayed in the following galleries:";
			break;

		case 1:
		default:
			section_title = "Confirmation!";
			section_subtitle = "Are you sure that you want to delete this entry?";
			break;
	}

	return (
		<FloatingLayer backButton={props.backButton}>
			<div class="without_actions gui_flexbox gui_flex_row">
				<div class="gui_not_in_end_big">
					<ul class="gui_multimedia_gallery only_gallery">
						<OnlyGallery
							user={{ Participation:response.participation }}
						/>
					</ul>
				</div>

				<div>
					<SectionTitle _class={{icon:'knk-alert redIcon'}}>{section_title}</SectionTitle>
					<SectionSubtitle>{section_subtitle}</SectionSubtitle>

					{(response.status == 0) && (
						<Message
							icon={false}
							_class={{ other:'in_top' }}
						>
							<ul class="votes_per_gallery">
								{response.stages && response.stages.map((_stage) => {
									const stage = _stage.Stage;
									const vote_count = _stage.StageVote.points;
									return (
										<li key={stage.id}>
											<strong>{getStageName(stage, i18n)}: </strong>
											<FormattedPlural value={vote_count} one={<FormattedMessage id="{num} point" values={{num:vote_count}} />} other={<FormattedMessage id="{num} points" values={{num:vote_count}} />} />
										</li>
									)
								})}
							</ul>
						</Message>
					)}

					{(response.status == 0) && (
						<SectionSubtitle _class={{other:'gui_not_in_top_big'}} autotranslate={false}><strong>{i18n("If you continue, the entry will stop showing in the gallery and we will remove all your votes.")}</strong></SectionSubtitle>
					)}

					<ButtonCollection>
						<ActionButton
							onClick={props.backButton}
							color='red'
							icon='knk-off'
						>Cancel</ActionButton>

						<SaveButton
							type="confirm"
							onClick={props.confirm}
							color='green'
							icon='knk-on'
						>Yes, continue</SaveButton>
					</ButtonCollection>
				</div>
			</div>
		</FloatingLayer>
	)
}

export default injectIntl(DeleteUserConfirm);